var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit02(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit-02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M15 8.3333L11.6667 4.99997M2.08331 17.9166L4.90362 17.6033C5.24819 17.565 5.42048 17.5458 5.58152 17.4937C5.72439 17.4475 5.86035 17.3821 5.98572 17.2994C6.12702 17.2063 6.2496 17.0837 6.49475 16.8385L17.5 5.8333C18.4205 4.91282 18.4205 3.42044 17.5 2.49996C16.5795 1.57949 15.0871 1.57949 14.1667 2.49996L3.16142 13.5052C2.91627 13.7503 2.79369 13.8729 2.70051 14.0142C2.61784 14.1396 2.55249 14.2756 2.50624 14.4184C2.45411 14.5795 2.43497 14.7518 2.39668 15.0963L2.08331 17.9166Z",
    stroke: "#101828",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit02);
export default __webpack_public_path__ + "static/media/edit-02.72061d9ad5c6a7c295c303d73e6ffefe.svg";
export { ForwardRef as ReactComponent };